/*eslint-disable*/
import React, { useState } from "react";
import {
  Row,
  Col,
  Typography,
  Image,
  Card,
  Button,
  Spin,
  Input,
  Checkbox,
  message,
} from "antd";
import "../components/aboutus.css";
import { useBreakpoints } from "./ResponsiveBreakPoints";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import TextArea from "antd/es/input/TextArea";
import { createEnquiry } from "../Actions/enquiryAction";

const AboutUs = ({ areas }) => {
  const { isCreateEnquiryLoading } = useSelector((state) => state.enquiries);
  const { isSuperLarge } = useBreakpoints();
  const dispatch = useDispatch();
  const areaLength = areas && areas?.length;
  const [termsAgreed, setTermsAgreed] = useState({
    isChecked: false,
    message: null,
  });
  const schema = Yup.object().shape({
    full_name: Yup.string().required("Required"),
    phone: Yup.string().required("Required"),
  });

  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const aboutusData = [
    {
      number: 36,
      title: "Years of experience",
    },

    {
      number: areaLength || 0,
      title: "Location Served",
    },
  ];

  const handleCheckboxChange = (e) => {
    setTermsAgreed({
      isChecked: e.target.checked,
      message: null,
    });
  };

  const handleCancel = () => {
    reset();
    setTermsAgreed({ isChecked: false, message: null });
  };

  const handleCreateForm = (data) => {
    if (!termsAgreed.isChecked) {
      setTermsAgreed({
        message: "Please agree to be contacted before submitting",
      });
      return;
    }
    dispatch(createEnquiry(data, successCreateEnquiry));
  };

  const successCreateEnquiry = () => {
    message.success("Your enquiry has been submitted successfully!");
    reset();
    setTermsAgreed({
      isChecked: false,
      message: null,
    });
  };
  return (
    <Row
      id="aboutus"
      justify="center"
      style={{ paddingTop: 20 }}
    >
      <Col
        xs={22}
        sm={22}
        md={22}
        lg={18}
        xl={20}
        xxl={16}
        style={{ maxWidth: isSuperLarge ? "50%" : "" }}
      >
      </Col>
    </Row>
  );
};
export default AboutUs;
